import styled from "styled-components";

const Container = styled.div`
  padding: 0;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: ${({ $autoHeight }) => ($autoHeight ? "0" : "400px")};

  img.icon,
  MuiTooltip-tooltip img.icon {
    height: 15px;
    width: 15px;
    margin-right: 4px;
    margin-bottom: -3px;
    filter: invert(30%);
  }

  .MuiDataGrid-columnHeaderTitleContainer {
    color: white;
    background-color: #555;
    height: 40px;
    overflow: hidden;
  }

  .MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-sortIcon {
    color: white;
  }

  .MuiDataGrid-menuIcon > button > svg {
    color: white;
  }

  .MuiDataGrid-columnHeaderTitleContainerContent
    > .MuiCheckbox-root
    > .MuiSvgIcon-root {
    color: rgba(255, 255, 255, 0.7);
    &:hover {
      color: white;
    }
  }

  .MuiDataGrid-cell {
    position: relative;
  }

  .MuiDataGrid-cell p {
    margin: 0;
  }

  /* Last comment: match Transaction grid preview + ellipsis */
  .MuiDataGrid-cell.last-comment-data-cell {
    align-items: flex-start !important;
    white-space: normal !important;
  }

  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-wrap {
    width: 100%;
    min-height: 0;
    overflow: hidden;
    position: relative;
    box-sizing: border-box;
    line-height: 1.43;
  }

  .MuiDataGrid-cell.last-comment-data-cell
    .last-comment-preview-wrap--truncated::after {
    content: "\\2026";
    position: absolute;
    right: 0;
    bottom: 0;
    line-height: 1;
    font-size: 14px;
    font-weight: 600;
    color: #56656b;
    pointer-events: none;
    text-shadow: 0 0 4px #fff, 0 0 8px #fff, 0 0 12px #fff;
  }

  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-html {
    font-size: 14px;
    color: #01151d;
    word-break: break-word;
  }

  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-html p {
    margin: 0 0 4px 0;
    padding: 0;
  }

  .MuiDataGrid-cell.last-comment-data-cell
    .last-comment-preview-html
    p:last-child {
    margin-bottom: 0;
  }

  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-html ul,
  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-html ol {
    margin: 0 0 4px 0;
    padding-left: 1.25rem;
  }

  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-html li {
    margin: 2px 0;
  }

  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-html strong,
  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-html b {
    font-weight: 600;
  }

  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-html em,
  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-html i {
    font-style: italic;
  }

  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-html a {
    color: #09779e;
  }

  .MuiDataGrid-cell.last-comment-data-cell .last-comment-preview-html .mention {
    color: #09779e;
    font-weight: 500;
    text-decoration: none;
  }

  .MuiDataGrid-cell .event-note-cell {
    display: block;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .MuiDataGrid-cell svg.lease-name-icon {
    margin-right: 5px;
  }

  .MuiDataGrid-cell .clickable {
    font-weight: bold;
  }

  .MuiDataGrid-cell .tooltip-button-container {
    position: absolute;
    right: 15px;
    top: 7px;
  }

  .MuiDataGrid-cell button.leaseEvents.tooltip-button {
    background: #eee;
    margin-top: 5px;
    border-radius: 20px;
    padding: 4px 10px;
    min-width: 25px;
    color: black;
  }

  .MuiButton-root.filter {
    margin-bottom: 15px;
    width: 130px;
  }

  .MuiOutlinedInput-root.search {
    position: absolute;
    right: 0;
    top: 20px;
    height: 35px;
  }

  .MuiOutlinedInput-root.MuiInputBase-root.filter {
    width: 100%;
    height: 50px;
  }

  .MuiTextField-root.notice-date-ranges {
    position: absolute;
    right: 0;
    top: 70px;
  }

  .MuiTextField-root.notice-date-ranges .MuiOutlinedInput-root {
    width: 170px;
    height: 35px;
  }

`;

const TableContainer = styled.div`
  width: 100%;
`;

export { Container, TableContainer };
